import { render } from "./DunningEnable.vue?vue&type=template&id=8fdd7f28"
import script from "./DunningEnable.vue?vue&type=script&lang=js"
export * from "./DunningEnable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__